import { safeString } from '@exodus/safe-string';
export const ExchangeStatus = {
    STARTED: 'started',
    IN_PROGRESS: 'inProgress',
    COMPLETE: 'complete',
    FAILED: 'failed',
};
Object.setPrototypeOf(ExchangeStatus, null);
export const SWAP_ALL_FEE_TOLERANCE = 0.2;
export const LOGS = Object.freeze({
    START_ACCOUNT_DISCOVERY_FAILED: safeString `Start Account Discovery Failed`,
    GETTING_ACCOUNT_NAME: safeString `Getting Account Name`,
    SIMULATING_TX: safeString `Simulating Tx`,
    UPSERTING_ORDER: safeString `Upserting Order`,
    FAILED_TO_UPSERT_ORDER: safeString `Failed to upsert order`,
});
